import sdk from '@trazi/billing-processor/sdk/node';

export default ({ app }, inject) => {
  inject('billingProcessorSDK', sdk(`${window.location.origin}/api`));
};
